import { MenuItem } from "@mui/material";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { SkiliticsIcon } from "../../icons";
import { ContextMenu } from "../../popup";
import type { MediaAssetSource } from "../controls";
import { mediaAssetSourceSchema } from "../controls";

type Props = {
  source: MediaAssetSource;
  onSourceChanged: (type: MediaAssetSource) => void;
};

export const MediaAssetSourceMenu = ({ source, onSourceChanged }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const options = mediaAssetSourceSchema.options.map((value) => value);

  return (
    <ContextMenu
      IconComponent={<SkiliticsIcon icon="additional-options" size={16} />}
      data-test="media-asset-context-menu"
    >
      {options.map((type) => (
        <MenuItem key={type} disabled={type === source} onClick={() => onSourceChanged(type)}>
          {formatMessage(type)}
        </MenuItem>
      ))}
    </ContextMenu>
  );
};

const formatStrings = {
  file: {
    en: "Upload file",
  },
  url: {
    en: "Embed URL",
  },
} satisfies FormatMessages;
